module.exports = __webpack_public_path__ + "img/P4-2-1.2185e0f1.png";